export default __webpack_public_path__ + "static/media/qr_input.15a67188.png";